import Api from '@/api/Api'
import store from '../store'

export default {

  async getAll (params) {
    return store.dispatch('checkResponseApi', await Api().get('pos/sessions', { params }))
  },

  async getMe () {
    return store.dispatch('checkResponseApi', await Api().get('pos/session/me'))
  },

  async getSingle (data) {
    return store.dispatch('checkResponseApi', await Api().get('pos/session?ps_id=' + data.ps_id))
  },

  async insert (params) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('pos/session', params, options))
  },

  async updateStatus (data) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('pos/session/status', data, options))
  },

  async getLatestCode (data) {
    return store.dispatch('checkResponseApi', await Api().get('pos/session/latest_code'))
  },

}



// WEBPACK FOOTER //
// ./src/api/PosSessionService.js